<template lang="pug">
section.block-wrapper.vld-parent
  section.block(:class="classes")
    Loading.fl-row(:active="loading" :is-full-page="false" color="#65a946")
    main
      header
        h3(v-if="title") {{ title }}

        .overlay(v-if="cancelling || saving")
          .lds-facebook
            div
            div
            div

        template(v-if="editable")
          .fl-columns(v-if="editing")
            button.undo(@click="onCancel" :disabled="!editing" :title="cancelTitle") Cancel
            button.save.ml-4(@click="onSave" :disabled="cancelling || saving || !valid || !dirty" :title="saveTitle") Save
          .icon-wrapper(v-else :title="editingTitle")
            FontAwesomeIcon.icon.edit(:icon='$icons.edit' @click="onEdit")

      form(@submit.prevent)
        slot(:bus="bus" :isEditing="editing")
</template>

<script>
import Vue from "vue";
import "./scss";
import { Arrays } from "@gemma/utils";
import { Events } from "./Events";
import { BLOCK } from "./BLOCK";

const componentStates = { cancelled: false, dirty: false, saved: false, valid: true };

export default {
  name: "Block",
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    editByDefault: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      blocks: {},
      bus: new Vue(),
      errors: [],
      cancelling: false,
      editing: this.editByDefault,
      dirty: false,
      saving: false,
      valid: true,
    };
  },
  computed: {
    classes() {
      const classes = [];

      if (this.editable) {
        classes.push("editable");
      }

      if (this.editing) {
        classes.push("block-editing");
      }

      if (this.cancelling) {
        classes.push("block-cancelling");
      }

      return classes;
    },
    editingTitle() {
      return `Start editing in '${this.title}'`;
    },
    cancelTitle() {
      return `Cancel all editing in '${this.title}'`;
    },
    saveTitle() {
      return `Save all changes in '${this.title}'`;
    },
  },
  created() {
    this.bus.$on(Events.Cancelled, this.onCancelled);
    this.bus.$on(Events.Created, this.addChild);
    this.bus.$on(Events.Dirty, this.onDirty);
    this.bus.$on(Events.Saved, this.onSaved);
    this.bus.$on(Events.Valid, this.onValid);
  },
  destroyed() {
    this.bus.$off(Events.Cancelled, this.onCancelled);
    this.bus.$off(Events.Created, this.addChild);
    this.bus.$off(Events.Dirty, this.onDirty);
    this.bus.$off(Events.Saved, this.onSaved);
    this.bus.$off(Events.Valid, this.onValid);
  },
  methods: {
    onCancel() {
      if (!this.cancelling) {
        this.cancelling = true;
        this.bus.$emit(Events.Cancel, BLOCK);
      }
    },
    onCancelled(id) {
      if (id !== BLOCK) {
        this.assignBlockProperty(Events.Cancelled, true, id);
        if (Object.keys(this.blocks).reduce((acc, key) => acc && this.blocks[key].cancelled, true)) {
          this.cancelling = false;
          this.editing = false;
          this.bus.$emit(Events.Cancelled, BLOCK);
        }
      }
    },
    onDirty({ id, state }) {
      if (id !== BLOCK && this.blocks[id].dirty !== state) {
        this.assignBlockProperty(Events.Dirty, state, id);
        this.dirty = Object.keys(this.blocks).reduce((acc, key) => acc || this.blocks[key].dirty === true, false);
        this.bus.$emit(Events.Dirty, { id: BLOCK, state: true });
      }
    },
    onEdit() {
      if (!this.editing) {
        this.cancelling = false;
        this.editing = true;
        this.bus.$emit(Events.Edit, { id: BLOCK, state: true });
      }
    },
    onSave() {
      this.errors = [];
      this.editing = false;
      this.saving = true;
      this.bus.$emit(Events.Edit, { id: BLOCK, state: false });
      this.bus.$emit(Events.Save, { id: BLOCK, state: true });
    },
    onSaved({ id, errors }) {
      if (id !== BLOCK) {
        Arrays.add(this.errors, errors);
        this.assignBlockProperty(Events.Saved, true, id);
        if (Object.keys(this.blocks).reduce((acc, key) => acc && this.blocks[key].saved, true)) {
          this.saving = false;
          this.bus.$emit(Events.Saved, { id: BLOCK, errors: this.errors });
        }
      }

      if (errors.length > 0) {
        this.editing = true;
        this.bus.$emit(Events.Edit, { id: BLOCK, state: this.editing, clearErrors: false });
      }
    },
    onValid({ id, state }) {
      if (id !== BLOCK && this.blocks[id].valid !== state) {
        this.assignBlockProperty(Events.Valid, state, id);
        this.valid = Object.keys(this.blocks).reduce((acc, key) => acc && this.blocks[key].valid !== false, true);
        this.bus.$emit(Events.Valid, { id: BLOCK, state: this.valid });
      }
    },
    addChild(id) {
      for (const key in componentStates) {
        this.assignBlockProperty(key, componentStates[key], id);
      }
    },
    assignBlockProperty(blockItemKey, value, id) {
      if (!this.blocks[id]) {
        this.blocks[id] = {};
      }

      this.blocks[id][blockItemKey] = value;
    },
  },
};
</script>
